import React from 'react'
import { Button, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { usePersonPageParams } from '../personPageRouteUtil'
import ResearchHelpContentSkeleton from '../../research-help/components/ResearchHelpContentSkeleton'

export default function HintsTabSkeleton(): JSX.Element {
  const [t] = useTranslation()
  const { pid } = usePersonPageParams('full')

  return (
    <>
      <ResearchHelpContentSkeleton />
      <Separator size="sm" />
      <Button
        emphasis="medium"
        to={`/research-help/${pid}/dismissed`}
        linkName="View Dismissed Hints"
        data-testid="view-dismissed-hints"
      >
        {t('research-help.view-dismissed-hints.action')}
      </Button>
    </>
  )
}
